module.exports = __webpack_public_path__ + "img/krs-ng-banner.b6880920.jpg";